export interface OrderPatchPriceRequest {
  sessionID?: string;
  requestDateTime?: string;
  FEMiddlewareDateTime?: string;
}
